<!-- Left side column. contains the sidebar -->
<aside class="main-sidebar">
    <!-- Logo -->
    <a class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini"><img src="assets/images/logo-icon.png" /></span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg"
            ><img src="assets/images/{{ companyService.getSelectedCompanyCode() }}-logo-light.png"
        /></span>
    </a>

    <section class="sidebar">
        <ul class="sidebar-menu" data-widget="tree">
            <li *ngFor="let navItem of navigationItems" class="menu-item">
                <a
                    [routerLink]="
                        !navItem.children || navItem.children.length === 0 ? navItem.path : null
                    "
                    (click)="
                        navItem.children && navItem.children.length > 0
                            ? toggleMenu(navItem.name, $event)
                            : null
                    "
                    routerLinkActive="active-sidebar-anchor active active-sidebar"
                    class="menu-link">
                    <ng-container *ngIf="navItem.isFaIcon; else imageIcon">
                        <i [class]="navItem.iconClass + ' sidebar-fa-icon'"></i>
                    </ng-container>

                    <ng-template #imageIcon>
                        <div [class]="navItem.iconClass"></div>
                    </ng-template>
                    <span>{{ navItem.name }}</span>
                    <i
                        *ngIf="navItem.children && navItem.children.length > 0"
                        class="fa menu-arrow"
                        [ngClass]="
                            expandedMenus[navItem.name] ? 'fa-angle-down' : 'fa-angle-right'
                        ">
                    </i>
                </a>

                <ul
                    class="submenu"
                    *ngIf="
                        navItem.children &&
                        navItem.children.length > 0 &&
                        expandedMenus[navItem.name]
                    ">
                    <li
                        *ngFor="let child of navItem.children"
                        class="submenu-item"
                        routerLinkActive="active-sidebar-anchor active active-sidebar">
                        <a [routerLink]="child.path">
                            <div [class]="child.iconClass"></div>
                            <span>{{ child.name }}</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </section>

    <section class="sidebar-footer">
        <div>{{ name }}</div>
        <div class="sidebar-menu-footer" (mouseenter)="mouseEnter()" (mouseleave)="mouseEnter()">
            <a (click)="logout()">
                <img src="assets/images/{{ iconName }}.png" />
                <span><u>Logout</u></span>
            </a>
        </div>
        <div class="sidebar-footer-copyright">All Rights Reserved © Lov.Cash</div>
        <div class="sidebar-footer-compressed">©</div>
    </section>
    <!-- /.sidebar -->
</aside>
<div id="logoutModal" class="image-modal" [style.display]="logoutModalDisplay">
    <div class="logout-window">
        <div class="section-heading mb-1">Are you sure you want to Logout?</div>
        <div>
            <button type="submit" class="box-outline submit-btn mb-2" (click)="submit()">
                Yes, Log Out
            </button>
            <a class="deny-window-close" (click)="closeModal()"><u>CANCEL</u></a>
        </div>
    </div>
</div>
